import { Image } from '@rocco/components/image';
import { SectionNotAvailable } from './SectionNotAvilable';
import { useLoaderData } from '@remix-run/react';
import type { loader } from '~/routes/_app.project.$urlSegment._index';

export const ProjectTeam = ({
    openEnquiryModal,
}: {
    openEnquiryModal: () => void;
}) => {
    const { teamMembers } = useLoaderData<typeof loader>();

    if (teamMembers.length === 0) {
        return (
            <SectionNotAvailable
                description={
                    <>
                        No team members info available for this project.
                        <br />
                        Request more information from this professional.
                    </>
                }
                enquiryButtonText="Request Project Team Info"
                openEnquiryModal={openEnquiryModal}
            />
        );
    }

    return (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-x-5 md:gap-y-12 md:py-17">
            {teamMembers.map((member) => (
                <div key={member.id} className="flex flex-col gap-6">
                    <div className="relative rounded-lg overflow-hidden grayscale hover:grayscale-0 transition-all duration-300">
                        <Image
                            src={member.detailsPageImageSrc}
                            alt={member.name}
                            width={348}
                            height={485}
                        />
                    </div>
                    <div className="flex flex-col">
                        <div className="text-base font-medium">
                            {member.name}
                        </div>
                        <div className="text-base font-medium text-gray-500">
                            {member.jobTitle}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
